import { render, staticRenderFns } from "./BCGovFooter.vue?vue&type=template&id=1561c87f&scoped=true"
import script from "./BCGovFooter.vue?vue&type=script&lang=js"
export * from "./BCGovFooter.vue?vue&type=script&lang=js"
import style0 from "./BCGovFooter.vue?vue&type=style&index=0&id=1561c87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561c87f",
  null
  
)

export default component.exports